import React from 'react';

const OurSpeciality = () => {
    return (
        <div className="col-lg-5 col-md-5">
            <div className="section_header">
                <h2 className="section_title">Our Speciality</h2>
                <h6 className="section_sub_title">
                    See our glorious journey as a restaurant
                </h6>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing tempor
                    incididunt ut labore et dolore magna aliqua. Ut ad minim
                    veniam, quis nostrud exercitation ullamco aliquip ex ea
                    commodo c.
                </p>
                <div className="button_group">
                    <a className="button">Learn More</a>
                </div>
            </div>
        </div>
    );
};

export default OurSpeciality;